import {
  Box,
  Typography
} from '@mui/material';
import React, { useState } from 'react';

import { LeadersFilters } from '../../../types';
import LeadersForm from './LeadersForm';
import LeadersPrecinctReport from './LeadersBarangayReport';

interface LeadersReportProps {
}

const LeadersReport: React.FC<LeadersReportProps> = () => {
  const [filters, setFilters] = useState<LeadersFilters>();

  const onGenerateReport = (filters: LeadersFilters) => {
    console.log('Generating report with filters:', filters);
    setFilters(filters);
  };

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Leaders
      </Typography>
      <LeadersForm onGenerateReport={onGenerateReport} />
      { filters && <LeadersPrecinctReport filters={filters} /> }
    </Box>
  );
};

export default LeadersReport;
